import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useCallback, useMemo, useState } from 'react'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import ECharts from '~/components/echarts'
import Select from '~/components/select'
import {
  awsInstanceCpuUtilizationMetricsResourceIdChartPath,
  awsInstanceMemoryMetricsResourceIdChartPath,
  awsInstanceNetworkInMetricsResourceIdChartPath,
  awsInstanceNetworkOutMetricsResourceIdChartPath,
} from '~/routes'

export default function AWSEC2MetricsCharts({ organizationId: orgId, resourceId: reId, hasMemoryData }) {
  const [params, setParams] = useState({ metrics_time_frame: '1w' })
  const metricsTimeFrames = useMemo(
    () => [
      { label: t`1 Week`, value: '1w', default: true },
      { label: t`1 Month`, value: '1m' },
      { label: t`3 Months`, value: '3m' },
    ],
    [],
  )

  const onChange = useCallback((name, values) => {
    // update params when a filter is selected
    setParams((prevParams) => ({ ...prevParams, [name]: values }))
  }, [])

  const awsInstanceCpuUtilizationMetricsResourceIdChartUrl = useMemo(
    () => awsInstanceCpuUtilizationMetricsResourceIdChartPath(orgId, reId),
    [orgId, reId],
  )
  const awsInstanceMemoryMetricsResourceIdChartUrl = useMemo(
    () => awsInstanceMemoryMetricsResourceIdChartPath(orgId, reId),
    [orgId, reId],
  )
  const awsInstanceNetworkInMetricsResourceIdChartUrl = useMemo(
    () => awsInstanceNetworkInMetricsResourceIdChartPath(orgId, reId),
    [orgId, reId],
  )
  const awsInstanceNetworkOutMetricsResourceIdChartUrl = useMemo(
    () => awsInstanceNetworkOutMetricsResourceIdChartPath(orgId, reId),
    [orgId, reId],
  )

  return (
    <div className='card'>
      <h3 className='card-header'>
        <Trans>Cloudwatch Information</Trans>
      </h3>
      <div className='card-body'>
        <div className='row mb-3 gx-2 gy-2 align-items-center'>
          <div className='col-sm-4'>
            <Select
              label={t`Time Frame`}
              name='metrics_time_frame'
              onChange={onChange}
              options={metricsTimeFrames}
              selected={params.metrics_time_frame}
            />
          </div>
        </div>
        <Tabs id='uncontrolled-metrics-tabs' className='mb-3'>
          <Tab eventKey='cpu-consumption-tab' title={t`CPU Consumption`}>
            <div className='row g-0'>
              <div className='col-sm-12'>
                <ECharts
                  title={t`CPU Consumption`}
                  chartInfoTitle='aws_ec2_cpu_utilization'
                  url={awsInstanceCpuUtilizationMetricsResourceIdChartUrl}
                  params={params}
                />
              </div>
            </div>
          </Tab>
          {hasMemoryData && (
            <Tab eventKey='memory-tab' title={t`Memory`} mountOnEnter>
              <div className='row g-0'>
                <div className='col-sm-12'>
                  <ECharts
                    title={t`Memory Utilization`}
                    chartInfoTitle='aws_ec2_memory_utilization'
                    url={awsInstanceMemoryMetricsResourceIdChartUrl}
                    params={params}
                  />
                </div>
              </div>
            </Tab>
          )}
          <Tab eventKey='network-tab' title={t`Network`} mountOnEnter>
            <div className='row g-0'>
              <div className='col-sm-12'>
                <ECharts
                  title={t`Network IN`}
                  chartInfoTitle='aws_ec2_network_in'
                  url={awsInstanceNetworkInMetricsResourceIdChartUrl}
                  params={params}
                />
              </div>
              <div className='col-sm-12'>
                <ECharts
                  title={t`Network Out`}
                  chartInfoTitle='aws_ec2_network_out'
                  url={awsInstanceNetworkOutMetricsResourceIdChartUrl}
                  params={params}
                />
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  )
}
